import HeaderBar from "../../../components/header/headerBar";
import { TextBox, Input } from "../../../components/textfield";
import { useParams } from "react-router-dom";
import { Table, TableColumn } from "../../../components/table";
import { mdiPrinter, mdiEyeOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios"
import moment from "moment";
interface ParamTypes {
  id: string;
}

const PaymentHistory = () => {
  const history = useHistory();
  const { id } = useParams<ParamTypes>();
  const [dataSO, setDataSO] = useState<any>({});
  const [paymentRecord, setPaymentRecord] = useState<any>([]);
  const columns = [
    {
      title: "",
    },
    {
      title: "เลขที่ใบเสร็จ/Receipt Number",
    },
    {
      title: "จำนวน(บาท)/Amount (Baht)",
      align: "center",
    },
    {
      title: "วันที่ชำระเงิน/Payment Date",
      align: "center",
    },
    {
      title: "ดูข้อมูล/View",
      align: "center",
    },
    {
      title: "ใบเสร็จ/Receipt",
      align: "center",
    },
    {
      title: "ใบกำกับภาษี/Tax Invoice",
      align: "center",
    },
  ];

  useEffect(() => {
    axios.get(`/so/get-so?soId=${id}`).then((res) => {
      setDataSO(res?.data)
      console.log(res?.data)
    });
    axios.get(`/payments/recordSO?so=${id}`).then((res) => {
      setPaymentRecord(res?.data)
    });
  }, [id]);
  const NumberFormat = (number: number) => {
    return new Intl.NumberFormat().format(number)
  }
  return (
    <div>
      <HeaderBar title={`CASHIER/Payment History/${dataSO?.code}`} btnBack />
      <div style={{ margin: "20px 40px" }}>
        <div className="card-view" style={{ padding: "30px 20px" }}>
          <div className="row">
            <TextBox className="col-3 col-sm-6 col-md-3" title="รหัสลูกค้า/CN" value={dataSO?.customerCode} />
            <TextBox className="col-3 col-sm-6 col-md-3" title="รหัสการขาย/SO" value={dataSO?.code} />
            <TextBox className="col-3 col-sm-6 col-md-3" title="เลขที่ใบยา/Ref.VN" value={dataSO?.vn} />
            <TextBox className="col-3 col-sm-6 col-md-3" title="ชื่อลูกค้า/Customer Name" value={dataSO?.customer} />
          </div>
        </div>
        <div style={{ marginTop: "50px" }}>
          <h5>รายการประวัติการชำระเงิน/Payment History List</h5>
          <Table header={columns}>
            {
              paymentRecord.map((item: any, index: number) => (
                <tr key={index} style={{ cursor: "pointer" }}>
                  <TableColumn width="5%" align="center">
                    {index + 1}
                  </TableColumn>
                  <TableColumn width="45%">{item?.code}</TableColumn>
                  <TableColumn width="10%" align="center">
                    {NumberFormat(item?.paymentAmount)}
                  </TableColumn>
                  <TableColumn width="10%" align="center">
                    {moment(item?.updatedAt).format('DD-MM-YYYY')}
                  </TableColumn>
                  <TableColumn width="10%" align="center">
                    <div
                      onClick={() => {
                        history.push(`/cashier/${id}/${item?._id}/history/detail`);
                      }}
                    >
                      <Icon path={mdiEyeOutline} size="20" color="#5BAEA9" />
                    </div>
                  </TableColumn>
                  <TableColumn width="10%" align="center" onClick={() => {
                    if (item?.paymentForm === "PayDeposit") { 
                      history.push(`/cashier/${id}/${item?._id}/receiptPayDeposit`);
                    } else {
                      history.push(`/cashier/${id}/${item?._id}/receipt`);
                    }
                  }}>
                    <Icon path={mdiPrinter} size="20" color="#5BAEA9" />
                  </TableColumn>
                  <TableColumn width="10%" align="center" onClick={() => {
                    history.push(`/cashier/${id}/${item?._id}/tax/history`);
                  }}>
                    <Icon path={mdiPrinter} size="20" color="#5BAEA9" />
                  </TableColumn>
                </tr>
              ))
            }
          </Table>
        </div>
      </div>
    </div>
  );
};
export default PaymentHistory;
